import React, { useContext } from "react";
import { UserContext } from "../../../../contexts/userProvider";
import Icons from "./icons"; // Importando o componente de ícones

const Normal = (props) => {
  const { signOut } = useContext(UserContext);

  const handleClick = () => {
    if (props.title === "Sair") {
      signOut();
    } else {
      props.handleLinkClick(props.title);
    }
  };

  return (
    <div 
      className={`flex items-center p-3 cursor-pointer group transition-all duration-200 hover:transform hover:translate-x-1 ${!props.sideBar ? 'justify-center' : ''}`} 
      onClick={handleClick}
      data-tour-id={`menu:${props.title}`}
    >
      <div className="flex items-center justify-center w-8 h-8 text-white group-hover:text-vox-green-400 transition-colors duration-200">
        {Icons(props.title, props.sideBar)}
      </div>
      {props.sideBar && (
        <span className="ml-3 font-medium text-white group-hover:text-vox-green-400 transition-colors duration-200 whitespace-nowrap">
          {props.title}
        </span>
      )}
    </div>
  );
};

export default Normal;
